import React, { useState } from "react";
import { Slide, toast } from "react-toastify";

interface PasswordConfirmProperties {
  showPasswordDialogue: boolean;
  desiredPassword: string;
  correctPasswordCallback(): void;
  wrongPasswordCallback(): void;
}

const PasswordConfirm = (props: PasswordConfirmProperties) => {
  const [pwEntered, setPwEntered] = useState("");

  function simpleHash(str: string) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0; // convert to 32bit integer
    }
    return (hash >>> 0).toString(36).padStart(7, "0");
  }

  const checkPassword = () => {
    if (simpleHash(pwEntered) == props.desiredPassword) {
      setPwEntered("");
      toast.success("Password Correct", {
        position: "bottom-center",
        autoClose: 1000,
        theme: "colored",
        transition: Slide,
      });
      props.correctPasswordCallback();
    } else {
      setPwEntered("");
      toast.error("Incorrect Password", {
        position: "bottom-center",
        autoClose: 2000,
        theme: "colored",
        transition: Slide,
      });

      props.wrongPasswordCallback();
    }
  };

  const inputChanged = (event: { target: { value: string } }) => {
    setPwEntered(event.target.value);
  };

  return (
    <div
      className={
        props.showPasswordDialogue ? "pw-confirm-open" : "pw-confirm-closed"
      }
    >
      <div
        id="pw-confirm-modal-mask"
        onClick={props.wrongPasswordCallback}
        className="modal-mask"
      />
      <div className="pw-confirm-dialgue">
        <span className="pw-confirm-label">
          Please enter the Partner Password
        </span>
        <div className="pw-confirm-input-wrapper">
          <input
            id="pwConfirmInputField"
            className="pw-confirm-input-box"
            type="password"
            placeholder="Password"
            value={pwEntered}
            onChange={inputChanged}
          />
          <button className="pw-confirm-input-button" onClick={checkPassword}>
            &#x2714;
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordConfirm;
